import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo-header.png";

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const navItems = [
    { name: "Home", path: "/", isExternal: false },
    { name: "Contato", path: "/contato", isExternal: false },
    { name: "Casting", path: "/trabalhe-conosco", isExternal: false },
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1b1b1b] animate-fade-down">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo on the left */}
          <Link to="/" className="flex items-center group">
            <img 
              src={logo} 
              alt="TH Coquetelaria" 
              className="h-7 sm:h-10 w-auto transition-opacity duration-300 group-hover:opacity-80" 
              width={115}
              height={40}
            />
          </Link>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              item.isExternal ? (
                <a
                  key={item.path}
                  href={item.path}
                  className="relative text-sm font-medium text-white transition-colors duration-300 after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-[-4px] after:left-0 after:bg-gold after:origin-bottom-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-bottom-left"
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  className="relative text-sm font-medium text-white transition-colors duration-300 after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-[-4px] after:left-0 after:bg-gold after:origin-bottom-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-bottom-left"
                >
                  {item.name}
                </Link>
              )
            ))}

            <Button 
              asChild 
              variant="outline"
              className="bg-transparent border-white/30 text-white hover:bg-white hover:text-black rounded-[4px] text-xs px-4 transition-colors duration-300"
            >
              <Link to="/proposta">Proposta</Link>
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#1b1b1b] border-t border-white/10 animate-fade-in">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            {navItems.map((item) => (
              item.isExternal ? (
                <a
                  key={item.path}
                  href={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-sm font-medium text-white py-2"
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-sm font-medium text-white py-2"
                >
                  {item.name}
                </Link>
              )
            ))}
            <Button 
              asChild 
              variant="outline"
              className="bg-transparent border-white/30 text-white hover:bg-white hover:text-black rounded-[4px] text-xs px-4 w-fit transition-colors duration-300"
            >
              <Link to="/proposta" onClick={() => setIsMenuOpen(false)}>Proposta</Link>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;